import * as React from "react";
import { cn } from "@/lib/utils";

const ShadcnCard = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      "rounded-xl border border-white/10 text-white shadow",
      className
    )}
    style={{
      backgroundColor: "rgba(235, 220, 207, 0.045)",
      backdropFilter: "blur(1000px)",
      WebkitBackdropFilter: "blur(1000px)",
    }}
    {...props}
  />
));
ShadcnCard.displayName = "ShadcnCard";

const ShadcnCardHeader = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("flex flex-col space-y-1.5 p-6", className)}
    {...props}
  />
));
ShadcnCardHeader.displayName = "ShadcnCardHeader";

const ShadcnCardTitle = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLHeadingElement>
>(({ className, ...props }, ref) => (
  <h3
    ref={ref}
    className={cn("font-semibold leading-none tracking-tight text-[#FAF1E9]", className)}
    {...props}
  />
));
ShadcnCardTitle.displayName = "ShadcnCardTitle";

const ShadcnCardDescription = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLParagraphElement>
>(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn("text-sm text-[#FAF1E9]/70", className)}
    {...props}
  />
));
ShadcnCardDescription.displayName = "ShadcnCardDescription";

const ShadcnCardContent = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div ref={ref} className={cn("p-6 pt-0 text-white", className)} {...props} />
));
ShadcnCardContent.displayName = "ShadcnCardContent";

const ShadcnCardFooter = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("flex items-center p-6 pt-0", className)}
    {...props}
  />
));
ShadcnCardFooter.displayName = "ShadcnCardFooter";

export {
  ShadcnCard,
  ShadcnCardHeader,
  ShadcnCardFooter,
  ShadcnCardTitle,
  ShadcnCardDescription,
  ShadcnCardContent,
};
